import React from "react";

import { Link, Typography } from "@mui/material";

import Emoji from "a11y-react-emoji";

export const IntroTourStep = () => (
  <>
    <Typography variant="h1" paragraph>
      Welcome to the London High Streets Map Explorer!&nbsp;
      <Emoji symbol="✨" label="sparkle" />
    </Typography>
    <Typography variant="body1" paragraph>
      If you're new take this whistle-stop tour to get acquainted with the
      map and its controls.
    </Typography>
  </>
);

export const FocusAreaLayerTourStep = () => (
  <Typography variant="body1" paragraph>
    Select <Emoji symbol="👆" label="index pointing up" /> to change the
    type of highstreet or district for exploration.
  </Typography>
);

export const FocusAreaTourStep = () => (
  <Typography variant="body1" paragraph>
    Click <Emoji symbol="🖱️" label="mouse" /> on a highstreet on the map to
    begin exploring it. Hover over a highstreet to reveal it's name&nbsp;
    <Emoji symbol="🔍" label="map" />
  </Typography>
);

export const FocusAreaDetailsTourStep = () => (
  <Typography variant="body1" paragraph>
    To select another high street or change the focus area layer above you
    must first clear the current selection&nbsp;
    <Emoji symbol="❌" label="cross"></Emoji>
  </Typography>
);

export const RadiusSliderTourStep = () => (
  <>
    <Typography variant="body1" paragraph>
      The region for exploration around the selected highstreet can be
      adjusted using the slider and buttons&nbsp;
      <Emoji symbol="👆" label="index pointing up" />
    </Typography>
  </>
);

export const TabsTourStep = () => (
  <>
    <Typography variant="body1" paragraph>
      Explore layers available to display on the map under the tabs.
    </Typography>
    <Typography variant="body1" paragraph>
      <b>Note:</b> Local Data Company business premise information, under the HSDS
      tab, is only available to members of the High Streets Data Service.
    </Typography>
  </>
);
export const LayersTourStep = () => (
  <>
    <Typography variant="body1" paragraph>
      To display a layer on the map click on the hollow circle&nbsp;
      <Emoji symbol="⭕" label="hollow circle"></Emoji> to the left of the
      layer name.
    </Typography>
    <Typography variant="body1" paragraph>
      The layer may not be available if it is not visible within the selected
      region <Emoji symbol="⛔" label="not available" />
    </Typography>
  </>
);

export const DownloadMapViewTourStep = () => (
  <>
    <Typography variant="body1" paragraph>
      The current map view may be downloaded&nbsp;
      <Emoji symbol="⬇️" label="arrow down"></Emoji> as a PNG image.
    </Typography>
  </>
);

export const TourStepFinal = () => (
  <>
    <Typography variant="body1" paragraph>
      We hope you enjoy exploring this map, but if you have any questions or
      comments please{" "}
      <Link
        underline="hover"
        href="mailto:HighStreetsDataService@london.gov.uk?subject=Feedback: London High Streets Map Explorer (from: tour)"
      >
        send them to us
      </Link>{" "}
      <Emoji symbol="💌" label="letter with love heart" />
    </Typography>
  </>
);
